module.exports = __webpack_public_path__ + "img/back exposed 7mm zipper length.91b8edcb.png";